import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { parseQuery, compileQuery } from 'utils';

import { Link } from 'react-router-dom';

import styles from './ChessLink.scss';
import cn from 'classnames';
import { withTranslation } from 'react-i18next';

class ChessLink extends Component {

  render() {
    const { className, prevLocation, match = {}, building: { data }, t } = this.props;
    const { url } = match;
    const prev = parseQuery(prevLocation);
    const filters = sessionStorage.getItem('filtersUrl');
    const { priceMin, priceMax, costMin, costMax, areaFrom, areaTo, interior, view_type } = filters ? parseQuery(filters.slice(2)) : {};
    const fromBuilding = true;
    const table = data.type_id == 2 ? 'list' : 'common';
    const from = 'building';
    const filtersSearch = compileQuery({ priceMin, priceMax, costMin, costMax, areaFrom, interior, areaTo, view_type, ...prev, fromBuilding, table, from });

    return (
      <Link className={cn(styles.ChessBtn, className, 'button-primary', 'button-primary--lg')} to={`${url}/chess?${filtersSearch}`}>
        <span className={styles.Hide1024}>{data.type_id !== 2 ? t('components.building.main.chessLink.seeChess') : t('components.building.main.chessLink.seeList')}</span>
        <span className={styles.Show1024}>{data.type_id !== 2 ? t('components.building.main.chessLink.chess') : t('components.building.main.chessLink.list')}</span>
      </Link>
    );
  }
}

const prevLocationSelector = state => state.building.prevLocation;

const chessLinkSelector = createSelector(
  prevLocationSelector,
  (prevLocation) => ({
    prevLocation
  })
);

export default withTranslation()(connect(chessLinkSelector)(ChessLink));



// WEBPACK FOOTER //
// ./src/components/Building/Main/ChessLink/ChessLink.js